import { useEffect, useMemo, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles'; // Import the useTheme hook from MUI
import AppIcons from 'src/utils/image'; // Assuming icons are imported here
import './Header.css'; // Custom CSS for Header
import Icon from '../Icon/Icon';
import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { AppConfig } from 'src/config/AppConfig';
import { useDispatch, useSelector } from 'react-redux';
import {
  setClientType,
  updateClientConfig,
  updateSelectedFilter,
} from 'src/slices/filterSlice';
import { useConfig } from 'src/context/ConfigContext';
import {
  selectBrands,
  selectLocations,
  selectReport,
  selectUserProfile,
  selectBrandsAsList,
} from 'src/app/selectors/appDataSelectors';
import { useNavigate } from 'react-router-dom';
import { logout } from 'src/app/actions';
import { isArray, isTypedArray } from 'lodash';
import { selectClientType } from 'src/app/selectors/filterSelectors';
import {
  updateClientLastOption,
  updateClientType,
} from 'src/config/firebaseConfig';
import CheckIcon from '@mui/icons-material/Check';
import { ClientTypeBrand } from 'src/types/brand';
import { ClientTypeLocation } from 'src/types/location';
import { capitalizeFirstLetter } from 'src/utils/Utils';
import { Refresh } from '@mui/icons-material';
import { clearCache } from 'src/api/filterApi';
import { updateActiveBrand } from 'src/slices/authSlice';
import {
  setSelectedMenu,
  setSelectedReportTile,
} from 'src/slices/appDataSlice';
import {getStoreIds} from 'src/slices/filterSlice';
const Header = ({
  toggleTheme,
  themeMode,
}: {
  toggleTheme: () => void;
  themeMode: 'light' | 'dark';
}) => {
  const dispatch = useDispatch();
  const { app } = useConfig();
  const { config } = useConfig();
  const navigate = useNavigate();
  const selectedMenu = useSelector(selectReport);
  const userProfile = useSelector(selectUserProfile);
  const clientType = useSelector(selectClientType);
  // Refs for dropdowns
  const appDropdownRef = useRef<HTMLDivElement>(null);
  const profileDropdownRef = useRef<HTMLDivElement>(null);
  const [isAppDropdownOpen, setIsAppDropdownOpen] = useState(false);
  const brands = useSelector(selectBrands);
  const locations = useSelector(selectLocations);
  const brandsAsList = useSelector(selectBrandsAsList);

  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  if (!userProfile) return <></>;
  const [selectedMerchantOption, setSelectedMerchantOption] = useState<string>(
    clientType == 'Brand' || clientType == 'NMS'
      ? userProfile.dash.activeBrand
      : userProfile.dash.activeLocationPartner,
  );
  const isDarkMode = themeMode === 'dark';

  let data = app;

  const theme = useTheme(); // Access the current theme here

  useEffect(() => {

    if (!config) {
      console.error('no Config loaded');
      return;
    }
    if (clientType !== 'NMS') return;
  
    const headers = {
      Authorization: config['HEADER']['Authorization'],
    };

    dispatch(
      getStoreIds({
        url: config.API_URL.store_Ids,
        headers,
        brandsAsList,
      }))
  }, [config, dispatch, clientType]);

  const toggleAppDropdown = () => setIsAppDropdownOpen(!isAppDropdownOpen);
  const updateClientTypeFirebase = (data) => {
    updateClientLastOption(userProfile.uid, clientType, data);
  };
  const handleRefresh = () => {
    console.log('Refreshing the app...');

    // Clear in-memory cache (if applicable)
    clearCache();

    // Reload the page
    window.location.reload();
  };

  const updateSelectedApp = (data) => {
    updateClientType(userProfile.uid, data);
  };
  const handleClientTypeClick = (id: string) => {
    const selectedClientType = AppConfig.clientTypeList.find(
      (type) => type.id === id,
    );

    if (selectedClientType) {
      dispatch(setClientType(id));
      updateSelectedApp(id);
      setSelectedMerchantOption(
        id == 'Brand' || id == 'NMS'
          ? userProfile.dash.activeBrand
          : userProfile.dash.activeLocationPartner,
      );
      localStorage.setItem('clientType', id);
      let value = '';
      if (id === 'Brand' || id === 'NMS') {
        const option = userProfile.dash.activeBrand;
        const appdata = brands[option];

        value =
          appdata && appdata.bq_concept_name ? appdata.bq_concept_name : '';
      } else {
        value = userProfile.dash.activeLocationPartner;
      }

      dispatch(
        updateSelectedFilter({
          key: 'account',
          value: '' + value,
        }),
      );
      if (id === 'NMS') {
        //navigate('/nms-dash');
        //handleRefresh();
        navigate('/home/NMS-Alert-Zendesk');
        dispatch(setSelectedMenu(AppConfig.nmsMenus[0].report));
      }
    }

    toggleAppDropdown();
    const item = id == 'NMS' ? AppConfig.nmsMenus[0] : AppConfig.adminMenus[0];
    dispatch(setSelectedMenu(item.report));
    localStorage.setItem('selectedMenu', item.report);
    dispatch(updateSelectedFilter({ key: 'report', value: item.report }));
    localStorage.setItem('selectedReportTile', item.tile);
    localStorage.setItem('selectedReportTileTitle', item.alt);
    dispatch(setSelectedReportTile(item.tile));
  };

  const toggleProfileDropdown = () =>
    setIsProfileDropdownOpen(!isAppDropdownOpen);
  const handleProfileClick = (id: string) => {
    //dispatch(setClientType(id));
    toggleProfileDropdown();
  };

  useEffect(() => {
    dispatch(
      updateSelectedFilter({
        key: 'requester',
        value: '' + userProfile?.email,
      }),
    );
  }, []);
  const logoFill = '#ff6d0f';
  const handleOnChangeMerchant = (
    event: any,
    option: ClientTypeBrand | ClientTypeLocation,
  ) => {
    if (!option || option.length < 4) {
      console.log('option', option);
      return;
    }
    const appdata: ClientTypeBrand | ClientTypeLocation = option;
    let value = '';
    if (clientType === 'Brand' || clientType === 'NMS') {
      value = appdata && appdata.bq_concept_name ? appdata.bq_concept_name : '';
    } else {
      value = appdata && appdata.bq_account ? appdata.bq_account : '';
    }
    updateClientTypeFirebase(option.id);

    setSelectedMerchantOption(option.id);

    dispatch(
      updateClientConfig({
        ...appdata,
        brandKey: isArray(option) ? option[0] : option.id,
      }),
    );
    dispatch(
      updateSelectedFilter({
        key: 'account',
        value: '' + value,
      }),
    );
    if (clientType === 'Brand' || clientType === 'NMS') {
       dispatch(updateActiveBrand(option.id));
    }
  };

  useEffect(() => {
    setSelectedMerchantOption(
      clientType === 'Brand' || clientType === 'NMS'
        ? userProfile.dash.activeBrand
        : userProfile.dash.activeLocationPartner,
    );
  }, [clientType]);

  const logOut = () => {
    localStorage.clear();
    dispatch(logout());
    navigate('/login');
    indexedDB.databases().then((databases) => {
      databases.forEach((db) => {
        indexedDB.deleteDatabase(db.name);
      });
    });
  };

  // Close dropdowns if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        appDropdownRef.current &&
        !appDropdownRef.current.contains(event.target as Node) &&
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target as Node)
      ) {
        setIsAppDropdownOpen(false);
        setIsProfileDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const isInternalEmail = /@swyft|@zoomsystems/i.test(userProfile?.email || '');

  const filteredClientTypeList = useMemo(() => {
   if (!userProfile) return [];
    return isInternalEmail
     ? AppConfig.clientTypeList // show all 3 for internal users
     : AppConfig.clientTypeList.filter((item) => item.id !== 'NMS'); // hide NMS for external users
  }, [userProfile]);

  return (
    <header
      className="sticky top-0 w-full shadow-md z-10 flex items-center justify-between px-2 py-2"
      style={{
        backgroundColor: theme.palette.background.default, // Set the theme's background color
        color: theme.palette.text.primary, // Set the theme's text color
        paddingBottom: '0rem',
      }}
    >
      {/* Left: App Title and Logo */}
      <div className="flex items-center space-x-1">
        {/* <img src={AppIcons.logo} alt="Logo" className="h-10" /> */}
        <Icon src={AppIcons.logo} fill={logoFill} width={60} height={60} />
      </div>
      <Tooltip title={AppConfig.tooltipMapping[selectedMenu]}>
        <Typography
          style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.3rem' }}
          variant="h6"
        >
          {capitalizeFirstLetter(selectedMenu)}
        </Typography>
      </Tooltip>

      {/* Right: Refresh, App Context, and Profile */}
      <div className="flex items-center space-x-4">
        {/* Refresh Button */}
        <div
          onClick={handleRefresh}
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#ff6d0f',
            color: '#ffffff',
            borderRadius: '20px',
            padding: '5px 15px',
            cursor: 'pointer',
          }}
        >
          <Refresh style={{ color: '#ffffff', marginRight: '5px' }} />
          <Typography variant="body2" style={{ color: '#ffffff' }}>
            Refresh
          </Typography>
        </div>
        <IconButton onClick={toggleTheme} color="inherit">
          {' '}
          {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}{' '}
        </IconButton>

        {/* App Context Selector */}
        <div className="relative" ref={appDropdownRef}>
          {/* <button
            className="bg-gray-100 py-2 px-4 rounded hover:bg-gray-200"
            
          > */}
          <img
            src={AppIcons.clientType}
            alt="App Context"
            className="h-5 w-20"
            onClick={toggleAppDropdown}
            //width={20}
          />
          {/* </button> */}

          {isAppDropdownOpen && (
            <div
              className="dropdown-menu absolute bg-white shadow-lg p-4 mt-2 rounded z-50"
              style={{ backgroundColor: theme.palette.background.paper, width: '300px' }}
            >
              <ul>
                {/* {AppConfig.clientTypeList.map( */}
                {filteredClientTypeList.map(   
                  (type: { id: string; name: string }) => (
                    <li
                      key={type.id}
                      onClick={() => handleClientTypeClick(type.id)}
                      className="hover:bg-gray-100 p-2"
                    >
                      {type.id === clientType ? (
                        <CheckIcon />
                      ) : (
                        <CheckIcon
                          color={logoFill}
                          style={{ visibility: 'hidden', color: { logoFill } }}
                        />
                      )}{' '}
                      <span>{type.name}</span>
                    </li>
                  ),
                )}
              </ul>
            </div>
          )}
        </div>
        {/* {clientType == 'NMS' ? (
          <Typography variant="h8">NMS DASH</Typography>
        ) : (
          <></>
        )}
        {data && data.length > 0 && (
          <FormControl fullWidth>
            <Autocomplete
              options={data}
              value={clientType == 'Brand' ? app.name : (app.name ?? '')}
              getOptionLabel={(option) => option?.name || ''}
              onChange={handleOnChangeMerchant}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    clientType == 'Brand' || clientType == 'NMS'
                      ? brands[selectedMerchantOption]?.name
                      : locations[selectedMerchantOption]?.name
                  }
                  variant="outlined"
                />
              )}
              renderOption={(props, option) => (
                <MenuItem {...props} key={option.name} value={option.name}>
                  {clientType == 'Brand' ? option.name : option.name}
                </MenuItem>
              )}
            />
          </FormControl>
        )} */}

        {clientType == 'NMS' ? (
          // <Typography variant="h8">NMS DASH</Typography>
          <Typography variant="h8">Network Monitoring</Typography>
        ) : (
          data &&
          data.length > 0 && (
            <FormControl fullWidth>
              <Autocomplete
                options={data}
                //value={clientType == 'Brand' ? app.name : (app.name ?? '')}
                value={
                  clientType === 'Brand'
                    ? brands[selectedMerchantOption] ?? null
                    : clientType === 'Location'
                    ? locations[selectedMerchantOption] ?? null
                    : null
                }
                
                getOptionLabel={(option) => option?.name || ''}
                onChange={handleOnChangeMerchant}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      clientType == 'Brand'
                        ? brands[selectedMerchantOption]?.name
                        : locations[selectedMerchantOption]?.name
                    }
                    variant="outlined"
                  />
                )}
                renderOption={(props, option) =>
                  option.live ? (
                    <MenuItem {...props} key={option.name} value={option.name}>
                      {clientType == 'Brand' ? option.name : option.name}
                    </MenuItem>
                  ) : null
                }
              />
            </FormControl>
          )
        )}

        {/* Profile Picture */}
        <div className="relative" ref={profileDropdownRef}>
          <img
            src={AppIcons.person}
            alt="Profile"
            className="h-8 w-8 rounded-full"
            onClick={handleProfileClick}
          />
          {isProfileDropdownOpen && (
            <div
              className="dropdown-menu absolute bg-white shadow-lg p-4 mt-2 rounded z-50 right-0"
              style={{ backgroundColor: theme.palette.background.paper }}
            >
              <ul>
                {AppConfig.profileMenuList.map(
                  (type: { id: string; name: string }) => (
                    <li
                      key={type.id}
                      onClick={logOut}
                      className="hover:bg-gray-100 p-2"
                    >
                      {type.name}
                    </li>
                  ),
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
